import get from 'lodash/get';
import { RbGtmClient } from '../../lib/gtm/client';

export const trackGA4GlobalNavViewSubCategory = (item, context) => {
  const url = get(item, 'action.parameters.url', null);

  RbGtmClient.track({
    event: 'interact_element',
    action: 'click',
    is_outbound: false,
    is_nav: true,
    page_location: window.location.pathname,
    element: 'global_nav',
    element_text: item.label,
    element_url: url,
    context: JSON.stringify(context)
  });
};

export const trackGA4GlobalNavViewCategory = (item, context) => {
  const url = get(item, 'action.parameters.url', null);

  RbGtmClient.track({
    event: 'interact_element',
    action: 'expand',
    is_outbound: false,
    is_nav: true,
    page_location: window.location.pathname,
    element: 'global_nav',
    element_text: item.label,
    element_url: url,
    context: JSON.stringify(context)
  });
};
